// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2hbAR","title":"FrontImage_title__1LB7C"};